import { FC } from 'react';

type InfoMessageProps = {
  message: string;
};

const InfoMessage: FC<InfoMessageProps> = ({ message }) => (
  <div className="d-flex align-items-center">
    <em className="icon ni ni-info mr-1 text-primary" />
    <i>{message}</i>
  </div>
);

export default InfoMessage;
